export enum UnderwritingDataProvider {
  BreatheLife = 'BreatheLife',
  ExamOne = 'ExamOne',
  Ingenium = 'Ingenium',
  LexisNexis = 'LexisNexis',
}
